import { render, staticRenderFns } from "./ManufactureList.vue?vue&type=template&id=03f8d062&scoped=true"
import script from "./ManufactureList.vue?vue&type=script&lang=js"
export * from "./ManufactureList.vue?vue&type=script&lang=js"
import style0 from "./ManufactureList.vue?vue&type=style&index=0&id=03f8d062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f8d062",
  null
  
)

export default component.exports